import { useCallback } from "react";

import FaxIcon from "@mui/icons-material/Fax";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import { useAppSelector } from "app/hooks";
import { selectCurrentClinic } from "features/auth/auth-slice";
import { PATIENT_HEADER_QUERY } from "features/patients/use-patient.hook";
import useFax from "hooks/use-fax.hook";
import { useGetPatientQuery } from "services/patients";

import { UPLOAD_SOURCE } from "../fax-form/fax-form.constants";

type FaxMenuProps = {
  patientId?: number;
  source?: string;
  label?: string;
  expanded?: boolean;
  disabled?: boolean;
};

export default function FaxMenu({
  patientId,
  source = UPLOAD_SOURCE,
  label = "Fax",
  expanded = false,
  disabled = false
}: FaxMenuProps) {
  const { handleOpen, setSource } = useFax();
  const currentClinic = useAppSelector(selectCurrentClinic);
  const clinicHasFaxNumber = Boolean(currentClinic?.fax_phone);
  const { data: patient } = useGetPatientQuery(
    { patientId: patientId!, query: PATIENT_HEADER_QUERY },
    {
      skip: !Boolean(patientId)
    }
  );
  const openFaxForm = useCallback(() => {
    setSource(source);
    return handleOpen(patient);
  }, [patient, handleOpen, setSource, source]);

  if (!clinicHasFaxNumber) {
    return <></>;
  }

  if (!expanded) {
    return (
      <Tooltip title={label}>
        <IconButton
          onClick={openFaxForm}
          data-testid="fax-mini-button"
          disabled={disabled}
        >
          <FaxIcon />
        </IconButton>
      </Tooltip>
    );
  }
  return (
    <Button
      disabled={disabled}
      onClick={openFaxForm}
      data-testid="fax-expanded-button"
      startIcon={<FaxIcon />}
    >
      {label}
    </Button>
  );
}
